function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import { white, grey3, grey20, grey40, spacing32 } from '../../../../eden-style-constants';
import hexToRgba from "hex2rgba";
import styled from "styled-components";
import shared from "./shared";
const iconSpecificFontSize = "1.5rem";
const Component = styled.button.withConfig({
  componentId: "sc-1g7hsbc-0"
})(["", ";border:none;border-radius:50%;", ";font-size:", ";padding:0;", ";&[disabled],&[disabled]:hover{background:transparent;color:", ";}"], shared, ({
  size
}) => size === "large" ? `min-width: 3.5rem;
        min-height: 3.5rem;` : size === "small" ? `min-width: ${spacing32};
          min-height: ${spacing32};` : `min-width: 2.5rem;
    min-height: 2.5rem;`, iconSpecificFontSize, ({
  inverted,
  active
}) => inverted ? `
        color: ${white};
        &:hover{ color: ${white} }
        ${active ? `background: ${grey40};` : `background: none;

            &:hover {
                background: ${hexToRgba(grey40, 0.6)};
            }
      
            &:active {
                background: ${grey40};
            }`};
       ` : `
        color: currentcolor;
        &:hover { color: currentcolor };
        ${active ? `background: ${grey3};` : `background: transparent;

            &:hover {
                background: ${hexToRgba(grey3, 0.6)};
            }
        
            &:active {
                background: ${grey3};
            }`};
    `, grey20);
const Icon = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
  ref: ref,
  as: props.disabled ? "button" : props.href ? "a" : "button"
}), props.children));
Icon.defaultProps = {
  type: "button",
  size: "normal"
};
Icon.displayName = "Icon";
Icon.propTypes = {
  /** The icon */
  children: PropTypes.node.isRequired,

  /** Whether to apply styles that show the button as active */
  active: PropTypes.bool,

  /** Whether to apply styles that help the button stand out on a dark background */
  inverted: PropTypes.bool,

  /** The size of the button */
  size: PropTypes.oneOf(["small", "normal", "large"]),

  /** The [type of the button](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Attributes), if an href is present it will be the [type of the link](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes) */
  type: PropTypes.string,

  /** If the button should be disabled */
  disabled: PropTypes.bool,

  /** The link that the button should navigate to on click */
  href: PropTypes.string
};
export default Icon;